import styled from 'styled-components';

export const AddButton = styled.div`
  margin-left: 5px;
`;
